import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-end w-full" }
const _hoisted_2 = { class: "font-bold flex justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-center truncate text-xs"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RankingProgress = _resolveComponent("RankingProgress")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["bg-white w-full pt-7 px-4 rounded-2xl relative text-black-lp-100 flex flex-col justify-end", _ctx.containerClass],
      style: _ctx.containerStyle
    }, [
      _createVNode("div", {
        class: ["rounded-full absolute left-1/2 transform -translate-x-1/2 flex justify-center items-center", _ctx.rankTranslateClass]
      }, [
        (_ctx.isTopRank)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _ctx.rankIcon,
              alt: "ranking",
              style: _ctx.rankIconStyle
            }, null, 12, ["src"]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "rounded-full flex justify-center items-center p-3",
              style: _ctx.rankCircleStyle
            }, [
              _createVNode("span", {
                class: "bg-white text-black-lp-300 font-bold w-full h-full rounded-full flex items-center justify-center",
                style: { fontSize: _ctx.rankFontSize }
              }, _toDisplayString(_ctx.formatNumber(_ctx.data.rank)), 5)
            ], 4))
      ], 2),
      (_ctx.data.rankDelta)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["absolute left-1/2 transform -translate-x-1/2", [_ctx.rankDeltaTranslateClass, _ctx.rankDeltaMarginClass]]
          }, [
            _createVNode(_component_RankingProgress, {
              increase: _ctx.data.rankDelta > 0,
              progress: _ctx.data.rankDelta
            }, null, 8, ["increase", "progress"])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_2, [
        (_ctx.isNewPos || _ctx.isRightPodium)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('dashboard.leaderboard.podium.title.rank')) + " " + _toDisplayString(_ctx.isNewPos ? _ctx.$t('dashboard.leaderboard.podium.title.newPos') : _ctx.$t('dashboard.leaderboard.podium.title.area')) + " ", 1),
              _withDirectives(_createVNode("span", { class: "font-normal" }, " (" + _toDisplayString(_ctx.data.rankTitle) + ") ", 513), [
                [_vShow, _ctx.data.rankTitle]
              ])
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('dashboard.leaderboard.podium.title.national')), 1))
      ]),
      _createVNode("span", {
        class: ["text-center", _ctx.rewardLabelClass]
      }, _toDisplayString(_ctx.$t('dashboard.leaderboard.podium.reward.label')), 3),
      _createVNode("span", {
        class: ["font-bold text-center", _ctx.rewardValueClass]
      }, _toDisplayString(_ctx.formatPriceRP(_ctx.data.estimatedReward, _ctx.accountCurrency)), 3)
    ], 6)
  ]))
}